SelectArchivableController.$inject = ['$translate', '$scope', '$state', '$stateParams', '$rootScope', '$mdDialog', 'archivableTaskIdsLength', 'selectedTasksIdsLength'];
export function SelectArchivableController($translate, $scope, $state, $stateParams, $rootScope, $mdDialog, archivableTaskIdsLength, selectedTasksIdsLength) {
  
  $scope.selectAllArchivable = selectAllArchivable;
  $scope.no = no;

  init();
  
  function selectAllArchivable() {
    $mdDialog.hide(true);
  }
  
  function no() {
    $mdDialog.hide();
  }

  function init() {
    $scope.contentLabel = $translate.instant('archive-in-search/select-archivable-dialog/start') + ' ' 
                          + selectedTasksIdsLength + ' ' 
                          + $translate.instant('archive-in-search/select-archivable-dialog/middle') + ' '
                          + archivableTaskIdsLength + ' '
                          + $translate.instant('archive-in-search/select-archivable-dialog/end');
  }
}